// assets/sidebar-assist.js

class Sidebar {
  constructor() {
    console.log('Sidebar: Initializing');
    this.sidebar = document.querySelector('.aside--sidebar');
    this.content = document.getElementById('sidebar-content');
    this.inner = document.getElementsByClassName('sidebar-inner');
    this.currentType = null;
    this.previousActiveElement = null;

    // Focus trap elements
    this.focusableElements = 'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])';
    this.firstFocusableElement = null;
    this.lastFocusableElement = null;

    this.bindEvents();
    console.log('Sidebar: Initialization complete');
  }

  bindEvents() {
    console.log('Sidebar: Binding events');

    // Trigger buttons
    document.querySelectorAll('[data-sidebar-target]').forEach((trigger) => {
      console.log('Sidebar: Found trigger button:', trigger);
      trigger.addEventListener('click', (event) => {
        // If button has popover target and popover function is available, skip sidebar
        if (trigger.hasAttribute('data-popover-target') && window.openProductPopover) {
          console.log('Sidebar: Skipping sidebar for popover target');
          return;
        }

        event.preventDefault();
        const target = trigger.getAttribute('data-sidebar-target');
        console.log('Sidebar: Trigger clicked for target:', target);
        this.open(target);
      });
    });

    this.sidebar.addEventListener('click', (event) => {
      if (event.target.closest('[data-sidebar-event="close"]')) {
        this.close();
      }
    });

    // Keyboard events - accessibility
    document.addEventListener('keydown', (event) => {
      if (!document.body.classList.contains('sidebar-open')) return;

      if (event.key === 'Escape') {
        this.close();
      } else if (event.key === 'Tab') {
        this.trapTabKey(event);
      }
    });

    // Add click handler outside content
    document.addEventListener('click', (event) => {
      if (!document.body.classList.contains('sidebar-open')) return;

      if (event.target === document.querySelector('body.sidebar-open')) {
        this.close();
      }

      const sidebarInner = event.target.closest('.sidebar-inner');
      if (!sidebarInner) return;

      const isClickOnContent = event.target.closest('#sidebar-content');
      const isClickOnClose = event.target.closest('.sidebar-close');

      if (!isClickOnContent && !isClickOnClose) {
        this.close();
      }
    });
  }

  open(type, skipTemplate = false) {
    console.log('Sidebar: Opening sidebar for type:', type);

    if (!skipTemplate) {
      const template = document.getElementById(`sidebar-${type}-template`);
      console.log('Sidebar: Found template:', template);
      if (!template) {
        console.warn('Sidebar: No template found for type:', type);
        return;
      }

      console.log('Sidebar: Template content:', template.innerHTML);
      this.content.innerHTML = template.innerHTML;
      console.log('Sidebar: Content updated');
    }

    this.currentType = type;
    this.previousActiveElement = document.activeElement;

    // Show sidebar
    this.sidebar.classList.remove('translate-x-full');
    this.sidebar.classList.add('left-0', 'lg:left-auto');
    document.body.classList.add('sidebar-open');

    // Handle focus trap
    const focusableContent = this.sidebar.querySelectorAll(this.focusableElements);
    this.firstFocusableElement = focusableContent[0];
    this.lastFocusableElement = focusableContent[focusableContent.length - 1];

    if (this.firstFocusableElement) {
      //this.firstFocusableElement.focus();
    }

    // Dispatch event after opening
    document.dispatchEvent(new CustomEvent(`sidebar:${type}-loaded`));
  }

  close() {
    // Hide sidebar
    this.sidebar.classList.add('translate-x-full');
    this.sidebar.classList.remove('left-0', 'lg:left-auto');
    document.body.classList.remove('sidebar-open');

    // Restore focus
    if (this.previousActiveElement) {
      this.previousActiveElement.focus();
    }
  }

  trapTabKey(event) {
    if (!this.firstFocusableElement || !this.lastFocusableElement) return;

    if (event.shiftKey) {
      if (document.activeElement === this.firstFocusableElement) {
        event.preventDefault();
        this.lastFocusableElement.focus();
      }
    } else {
      if (document.activeElement === this.lastFocusableElement) {
        event.preventDefault();
        this.firstFocusableElement.focus();
      }
    }
  }

  // Called after section refresh
  restoreContent() {
    if (this.currentType && document.body.classList.contains('sidebar-open')) {
      this.open(this.currentType);
    }
  }
}

// Initialize
let sidebar;
document.addEventListener('DOMContentLoaded', () => {
  sidebar = new Sidebar();
  // Expose sidebar instance globally for design mode
  window.sidebar = sidebar;
});

// Handle section refreshes
document.addEventListener('shopify:section:load', (event) => {
  if (event.target.classList.contains('sidebar-section')) {
    sidebar.restoreContent();
  }
});
